import { SortDirection } from 'ag-grid-community';

interface Props {
  sortDirection: SortDirection | undefined;
}

const AGGridSortIcon = ({ sortDirection }: Props) => {
  switch (sortDirection) {
    case 'asc':
      return (
        <span className="ag-header-icon">
          <span className="ag-icon ag-icon-asc" />
        </span>
      );
    case 'desc':
      return (
        <span className="ag-header-icon">
          <span className="ag-icon ag-icon-desc" />
        </span>
      );
    default:
      return null;
  }
};

export default AGGridSortIcon;
